import { render, staticRenderFns } from "./CourseDetails.vue?vue&type=template&id=174c7a29&scoped=true&"
import script from "./CourseDetails.vue?vue&type=script&lang=js&"
export * from "./CourseDetails.vue?vue&type=script&lang=js&"
import style0 from "./CourseDetails.vue?vue&type=style&index=0&id=174c7a29&lang=scss&scoped=true&"
import style1 from "./CourseDetails.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174c7a29",
  null
  
)

export default component.exports